import { render } from "./IndexTourist.vue?vue&type=template&id=279f2e70&scoped=true&ts=true"
import script from "./IndexTourist.vue?vue&type=script&lang=ts"
export * from "./IndexTourist.vue?vue&type=script&lang=ts"

import "./IndexTourist.vue?vue&type=style&index=0&id=279f2e70&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279f2e70"]])

export default __exports__